/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedUsageStateEnum } from './disconnectedUsageStateEnum';
import { VlsrPersonaEnum } from './vlsrPersonaEnum';


export interface DisconnectedUsagePostSpec { 
    /**
     * Disconnected SRM pair UUID
     */
    entity_uuid: string;
    org_id: string;
    state: DisconnectedUsageStateEnum;
    persona: VlsrPersonaEnum;
    quantity: number;
    expiry_ts: Date;
}
export namespace DisconnectedUsagePostSpec {
}


